import { Directive } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FormUtility } from "./form-utility";
import { FormValidation } from "./form-validation";

export interface IFormObjectComponent {
  form: UntypedFormGroup;
  formCompleted: boolean;
  validateForm(): void;
  reset(): void;
}

@Directive()
export abstract class FormObjectComponent implements IFormObjectComponent {
  public abstract form: UntypedFormGroup;
  
  public formCompleted: boolean = false;
  
  public validateForm(): void {
    this.formCompleted = FormValidation.isValid(this.form);
  }
  
  public reset(): void {
    FormUtility.reset(this.form);
    this.formCompleted = false;
  }
  
  /**
   * Clears the value in the specified form field.
   * @param field The form field to clear.
   */
  public clear(field: string): void {
    FormUtility.clear(this.form, field);
  }

  /**
   * Gets a value indicating if the specified field has a value.
   * @param field The form field to check.
   * @returns If the field has a value, `true`; otherwise, `false`.
   */
  public hasValue(field: string): boolean {
    return FormUtility.hasValue(this.form, field)
  }
  
  /**
   * Prevents the specified field from exceeding a maximum value.
   * @param field 
   * @param maxValue 
   */
  public preventExceedingMaxValue(field: string, maxValue: number): void {
    if (this.form.controls[field].value > maxValue) {
      const value = this.form.controls[field].value.toString();
      this.form.controls[field].setValue(value.slice(0, -1));
    }
  }
}
